import React from 'react';
import {
  ColumnProps,
  LevelBarProps,
  RootineLevelBar,
  RootineTable,
  RowProps,
  TableProps,
} from '../../../atoms';
import { AnalyteReport } from '../../../types';

export interface AnalytesTableProps {
  analytes: AnalyteReport[];
  onClick: (i: number) => void;
}

export const AnalytesTable = (props: AnalytesTableProps): JSX.Element => {
  const rows = (): { [name: string]: RowProps }[] => {
    return props.analytes.map((analyte) => {
      const date = analyte.result_history[0].date
        ? new Date(Date.parse(analyte.result_history[0].date))
        : undefined;
      const levelBarProps: LevelBarProps = {
        level: analyte.result_history[0].result,
        optimalMax: analyte.optimal_max_value,
        optimalMin: analyte.optimal_min_value,
      };
      return {
        name: {
          value: analyte.name,
          bold: true,
        },
        result: {
          value:
            Math.round(analyte.result_history[0].result * 100) / 100 +
            ' ' +
            analyte.unit,
        },
        test_date: {
          value: date
            ? date.toLocaleString('default', {
                month: 'short',
              }) +
              ' ' +
              date.getDate() +
              ', ' +
              date.getFullYear()
            : 'Unavailable',
        },
        level: { value: RootineLevelBar({ ...levelBarProps }) },
      };
    });
  };

  const columns: { [name: string]: ColumnProps } = {
    name: {
      name: 'ANALYTE',
      tooltipText:
        'The substance that is of interest in the analysis (e.g. amount of calcium in the blood)',
    },
    result: { name: 'RESULT' },
    test_date: { name: 'TEST DATE' },
    level: {
      name: 'LEVEL',
      tooltipText: 'The amount detected during analysis',
      hideMobile: true,
    },
  };

  const betterTableProps: TableProps = {
    tableName: 'analyte results',
    columns: columns,
    rows: rows(),
    onClick: props.onClick,
  };

  return <RootineTable {...betterTableProps} />;
};
